<template>
    <div class="pt-5 px-3 md:px-16 flex justify-between h-28 md:h-32 bg-primary text-white p-10 rounded-2xl">
        <div class="text-left mb-0">
          <h2 class="text-white text-[12px] md:text-[16px] mb-2 font-semibold text-center">IGD</h2>
          <hr>
          <p class="text-[10px] md:text-[14px] mt-2">- 089-537-554-0303</p>
          <p class="text-[10px] md:text-[14px]">- 024-764-185-87</p>
        </div>
        <div class="text-left mb-0">
          <h2 class="text-white text-[12px] md:text-[16px] mb-2 font-semibold text-center">Daftar Online</h2>
          <hr >
          <p class="text-[10px] md:text-[14px] mt-2">- 081-575-757-278</p>
          <p class="text-[10px] md:text-[14px] text-primary">- 081-575-757-278</p>
        </div>
        <div class="text-left mb-0">
          <h2 class="text-white text-[12px] md:text-[16px] mb-2 font-semibold text-center">Humas</h2>
          <hr >
          <p class="text-[10px] md:text-[14px] mt-2">- 087-827-777-173</p>
          <p class="text-[10px] md:text-[14px] text-primary">- 087-827-777-173</p>
        </div>
    </div>
</template>